import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { FC } from "react";

import { FurtherStepSection } from "./FurtherStepSection";

export const IncomingPostbackHeaderForm: FC = () => {
    return (
        <>
            <Collapseable title="Další kroky" className="bg-neutral-200">
                <FurtherStepSection />
            </Collapseable>
        </>
    );
};
